import React from 'react'
import AddEnergyOfficialsBreadCrumb from './AddEnergyOfficialsBreadCrumb';
import AddNewEnergyOfficials from './AddNewEnergyOfficials';
function AddNewEnergyOfficialsPage() {
    return ( 
        <div className= "container-fluid">
            <AddEnergyOfficialsBreadCrumb />
            <AddNewEnergyOfficials />
        </div>
     );
}

export default AddNewEnergyOfficialsPage;